import katsu1 from "../../static/images/update/시그니처 카츠@2x.png"; // import katsu1 from "../../static/images/detail-katsu1.png";
import katsu2 from "../../static/images/update/제주 흑돈 카츠@2x.png"; // import katsu2 from "../../static/images/detail-katsu2.png";
import katsu3 from "../../static/images/update/사보텐 정식@2x.png"; // import katsu3 from "../../static/images/detail-katsu3.png";
import katsu4 from "../../static/images/update/24겹 카사네 카츠@2x.png"; // import katsu4 from "../../static/images/detail-katsu4.png";
import katsu5 from "../../static/images/update/오리지널 카츠@2x.png"; // import katsu5 from "../../static/images/detail-katsu5.png";
import katsu6 from "../../static/images/update/더블업 모짜렐라 카츠@2x.png"; // import katsu6 from "../../static/images/detail-katsu6.png";
import katsu7 from "../../static/images/update/씨푸드 카츠@2x.png";// import katsu7 from "../../static/images/detail-katsu7.png";
import katsu8 from "../../static/images/update/김치 카츠나베@2x.png"; // import katsu8 from "../../static/images/detail-katsu8.png";
import katsu9 from "../../static/images/update/카츠나베@2x.png"; // import katsu9 from "../../static/images/detail-katsu9.png";
import katsu10 from "../../static/images/update/키즈 카츠@2x.png";// import katsu10 from "../../static/images/detail-katsu10.png";
import katsu11 from "../../static/images/update/Special Katsu Set _ 전복24랑한 치즈카츠.png";
// import katsu11 from "../../static/images/detail-katsu11.png";
// import katsu12 from "../../static/images/detail-katsu12.png";
import rice1 from "../../static/images/update/카츠동 정식@2x.png"; // import donburi1 from "../../static/images/detail-donburi1.png";
import rice2 from "../../static/images/update/김치 카츠동 정식@2x.png"; // import donburi2 from "../../static/images/detail-donburi2.png";img-p-pastel-gray
//2025-01-17 김민애님 요청으로 데이터 수정
import rice3 from "../../static/images/update/숯불차돌규동정식@2x.png"; // import donburi3 from "../../static/images/detail-donburi3.png";
import rice4 from "../../static/images/update/돌솥알밥 정식@2x.png"; // import donburi4 from "../../static/images/detail-donburi4.png";
import rice5 from "../../static/images/update/통새우 카레라이스 정식@2x.png"; // import donburi5 from "../../static/images/detail-donburi5-2.png";
// import donburi6 from "../../static/images/detail-donburi6.png";
// import donburi7 from "../../static/images/detail-donburi7.png";
import noodles1 from "../../static/images/update/차돌니꾸 우동정식@2x.png"; //import noodles1 from "../../static/images/detail-noodles1.png";
import noodles2 from "../../static/images/update/모리소바 정식@2x.png"; //import noodles2 from "../../static/images/detail-noodles2-2.png";
import noodles3 from "../../static/images/update/통새우카레 우동정식@2x.png"; //import noodles3 from "../../static/images/detail-noodles3.png";
import noodles4 from "../../static/images/update/김치 우동정식@2x.png"; //import noodles4 from "../../static/images/detail-noodles4.png";
import noodles5 from "../../static/images/update/유부꼬치 우동정식@2x.png";
import noodles6 from "../../static/images/update/Noodles Set _ 카라이 우동정식.png";
import side1 from "../../static/images/update/통새우 카츠(2마리)@2x.png"; // import side1 from "../../static/images/detail-side1.png";
import side2 from "../../static/images/update/통새우 카츠(5마리)@2x.png"; // import side2 from "../../static/images/detail-side2.png";
import side3 from "../../static/images/update/미니우동@2x.png"; // import side3 from "../../static/images/detail-side3.png";
import side4 from "../../static/images/update/카레소스@2x.png"; // import side4 from "../../static/images/detail-side4.png";
import side5 from "../../static/images/update/밥@2x.png"; // import side5 from "../../static/images/detail-side5.png";
// import side6 from "../../static/images/detail-side6.png";
// import side7 from "../../static/images/detail-side7.png";
// import side8 from "../../static/images/detail-side8.png";
import banner1 from "../../static/images/update/카츠1@2x.png";
import banner1_2 from "../../static/images/update/카츠2@2x.png";
//import banner1_1 from "../../static/images/img-p-saboten-detail1-1.jpg";
import banner2 from "../../static/images/update/라이스정식1@2x.png"; //import banner2 from "../../static/images/img-p-saboten-detail2.jpg";
import banner3 from "../../static/images/img-p-saboten-detail3.jpg";
import banner4 from "../../static/images/update/side menu@2x.png"; //import banner4 from "../../static/images/img-p-saboten-detail4.jpg";

export const bannerData = {
  katsu: banner1,
  katsu2: banner1_2,
  rice: banner2,
  noodles: banner3,
  side: banner4,
};

const SabotenMenuData = {
  katsu: [
    {
      image: katsu1,
      title: "시그니처 카츠 200g",
      enTitle: "Signature Katsu",
      description: "두툼한 돼지고기의 육즙이 가득한 시그니처 메뉴",
//      price: "17.0 / 16.0",
    },
    {
      image: katsu2,
      title: "제주 흑돈 카츠 150g",
      enTitle: "Jeju Black Pork Katsu",
      description: "제주 청정지역에서 자라 풍부한 육즙이 일품인 프리미엄 메뉴",
 //     price: "17.0 / 16.5",
    },
    {
      image: katsu3,
      title: "사보텐 정식",
      enTitle: "Saboten Set",
      description: "로스, 히레, 통새우카츠를 한 번에 만나는 베스트 셀러 메뉴",
//      price: "16.0",
    },
    {
      image: katsu4,
      title: "24겹 카사네 카츠",
      enTitle: "24 Layered Pork Katsu",
      description: "24겹의 얇게 져민 등심을 층층히 쌓아 만든 부드러운 식감의 메뉴",
//      price: "14.5",
    },
    {
      image: katsu5,
      title: "오리지널 카츠 130g",
      enTitle: "Original Katsu",
      description: "1966년 오픈부터 카츠의 정석을 지켜온 정통메뉴",
 //     price: "15.0 / 13.0",
    },
    // {
    //   image: katsu1,
    //   title: "사보텐 정식",
    //   enTitle: "Saboten Set",
    //   description:
    //     "하프 로스(65g), 미니 카츠(30g), 에비(통새우) 카츠를 한 번에 맛 볼 수 있는 정식",
    //   price: "15.5",
    // },
    // {
    //   image: katsu2,
    //   title: "카사네 카츠",
    //   enTitle: "24 layer prok katsu",
    //   description:
    //     "얇게 저민 등심을 24겹으로 층층이 쌓아 부드럽고 연한 식감의 카츠(120g)",
    //   price: "14.5",
    // },
    // {
    //   image: katsu3,
    //   title: "제주 흑돈 카츠(히레/로스)",
    //   enTitle: "jeju black pork katsu\n(tenderloin/sirloin)",
    //   description:
    //     "제주 청정 지역에서 자란 흑돈으로 만들어 더 고소하고 육즙이 풍부한 카츠(150g)",
    //   price: "16.0 / 15.5",
    // },
    // {
    //   image: katsu4,
    //   title: "씨푸드 카츠",
    //   enTitle: "assorted seafood katsu",
    //   description: "흰살생선, 통새우카츠, 새우살 카츠와 매콤 크림 소스",
    //   price: "15.5",
    // },
    // {
    //   image: katsu5,
    //   title: "정통 카츠(히레/로스)",
    //   enTitle: "original katsu(tenderloin/sirloin)",
    //   description: "1966년 신주쿠 오픈 때 부터 함께 한 54년 전통 메뉴(130g)",
    //   price: "14.0 / 12.5",
    // },
    // {
    //   image: katsu6,
    //   title: "시그니처 카츠(히레/로스)",
    //   enTitle: "saboten signature katsu\n(tenderloin/sirloin)",
    //   description:
    //     "3.5cm 두께의 두툼한 돈육을 두들겨 돼지고기의 진한 풍미와 육즙 가득한 사보텐 50주년 기념 카츠(200g)",
    //   price: "17.0 / 16.0",
    // },
    // {
    //   image: katsu7,
    //   title: "모짜렐라 치즈 카츠",
    //   enTitle: "mozzarella cheese katsu",
    //   description: "모짜렐라 치즈를 넣어 만든 치즈와 미니 돈카츠",
    //   price: "14.0",
    // },
    // {
    //   image: katsu8,
    //   title: "코돈부르카츠",
    //   enTitle: "cordon bleu katsu",
    //   description:
    //     "얇게 저민 등신 24겹 사이에 치즈와 야채가 가득 들어가 더욱 고소하고 아삭한 식감의 카츠",
    //   price: "16.0",
    // },
    // {
    //   image: katsu9,
    //   title: "비프함박카츠",
    //   enTitle: "beef hamburg katsu",
    //   description: "소고기를 가득 품은 바삭한 비프함박카츠",
    //   price: "16.0",
    // },
    // {
    //   image: katsu10,
    //   title: "김치 카츠 나베",
    //   enTitle: "kimchi katsu nabe",
    //   description:
    //     "김치를 넣은 얼큰하고 깊은 맛의 국물에 바삭한 통새우 카츠와 미니 카츠를 얹은 냄비 요리",
    //   price: "13.0",
    // },
    // {
    //   image: katsu11,
    //   title: "카츠 나베",
    //   enTitle: "katsu hot pot",
    //   description: "사보텐 특제 소스에 버섯과 야채, 카츠가 어우러진 냄비 요리",
    //   price: "11.5",
    // },
    // {
    //   image: katsu12,
    //   title: "키즈카츠\n(새우 카츠 or 치즈 카츠 선택)",
    //   enTitle: "kid katsu with udon and katsu\n(shrimp/cheese)",
    //   description:
    //     "사보텐 인기 메뉴 총집합! 1/2로스카츠, 우동, 주먹밥과 새우 카츠 또는 치즈카츠 선택",
    //   price: "9.0",
    // },
  ],
  katsu2: [
    {
      image: katsu6,
      title: "더블업 모짜렐라 카츠",
      enTitle: "Double-up Mozzarella Katsu",
      description: "모짜렐라를 듬뿍 넣어 고소한 풍미가 가득한 프리미엄 치즈 메뉴",
 //     price: "15.5",
    },
    {
      image: katsu7,
      title: "씨푸드 카츠",
      enTitle: "Assorted Seafood Katsu",
      description: "통새우 카츠와 새우 스테이크, 흰살생선 카츠가 조화로운 마니아 메뉴",
 //     price: "15.5",
    },
    {
      image: katsu8,
      title: "김치 카츠나베",
      enTitle: "Kimchi Katsu Nabe",
      description: "카츠와 통새우 카츠를 올리고 김치를 넣어 얼큰한 맛의 전골메뉴",
 //     price: "14.0",
    },
    {
      image: katsu9,
      title: "카츠나베",
      enTitle: "Katsu Nabe",
      description: "카츠와 통새우 카츠, 각종 버섯과 야채가 조화로운 전골메뉴",
 //     price: "13.5",
    },
    {
      image: katsu10,
      title: "키즈 카츠",
      enTitle: "Kid\'s Katsu",
      description: "로스, 우동, 주먹밥과 새우 or 치즈 카츠 (택 1)",
 //     price: "9.0",
    },
      //2025-01-17 김민애님 요청으로 삭제
    // {
    //   image: katsu11,
    //   title: "전복24랑한 치즈 카츠",
    //   enTitle: "Abalone Cheese Katsu",
    //   description: "카사네 등심으로 전복과 모짜렐라를 감싸 만든 매콤한 치즈 메뉴",
    // },
  ],
  rice: [
    {
      image: rice1,
      title: "카츠동 정식",
      enTitle: "Katsudon Set",
      description: "사보텐 특제 소스에 돈카츠와 계란이 어우러져 조화를 이루는 덮밥",
  //    price: "13.5",
    },
    {
      image: rice2,
      title: "김치 카츠동 정식",
      enTitle: "Kimchi Katsudon Set",
      description: "사보텐 특제 소스에 돈카츠와 김치가 만나 조화를 이루는 덮밥",
//      price: "14.0",
    },
      //2015-01-17 김민애님 요청으로 데이터 수정
    {
      image: rice3,
      title: "숯불차돌규동 정식",
      enTitle: "Charcoal-grilled Beef Brisket Donburi Set",
      description: "사보텐 특제 소스에 숯불향 가득 차돌양지 소고기와 계란이 어우러진 덮밥",
 //     price: "15.5",
    },
    {
      image: rice4,
      title: "돌솥알밥 정식",
      enTitle: "Hot Pot With Fish Roe Set",
      description: "뜨거운 뚝배기에 고소한 알을 듬뿍 올린 특제 돌솥 알밥",
 //     price: "13.5",
    },
    {
      image: rice5,
      title: "통새우 카레라이스 정식",
      enTitle: "Shrimp Curry Rice Set",
      description: "통새우 카츠를 올려 정통 카레와 곁들여 먹는 든든한 라이스",
  //    price: "13.0",
    },
  ],
  // donburi: [
  //   {
  //     image: donburi1,
  //     title: "숯불 규동",
  //     enTitle: "charcoal-grilled beef rice bowl",
  //     description: "숯불 향이 나는 소고기와 계란이 어우러진 덮밥",
  //     price: "15.0",
  //   },
  //   {
  //     image: donburi2,
  //     title: "돌솥 숯불 규동",
  //     enTitle: "charcoal-grilled beef hot pot",
  //     description: "숯불 향이 나는 소고기와 계란이 어우러진 돌솥덮밥",
  //     price: "15.5",
  //   },
  //   {
  //     image: donburi3,
  //     title: "카츠동",
  //     enTitle: "katsu rice bowl",
  //     description:
  //       "사보텐 특제 소스와 카츠, 계란이 어우러져 부드러운 카츠 덮밥",
  //     price: "13.0",
  //   },
  //   {
  //     image: donburi4,
  //     title: "김치카츠동",
  //     enTitle: "kimcho katsu rice bowl",
  //     description: "돈카츠와 김치가 환상적인 조화를 이루는 덮밥",
  //     price: "13.5",
  //   },
  //   {
  //     image: donburi5,
  //     title: "카레라이스",
  //     enTitle: "curry rice",
  //     description: "일본 전통식 카레라이스",
  //     price: "12.0",
  //   },
  //   {
  //     image: donburi6,
  //     title: "함박카츠동",
  //     enTitle: "hamburg katsu rice bowl",
  //     description:
  //       "사보텐 특제 소스에 부드러운 비프함박카츠와 계란이 어우러진 덮밥",
  //     price: "14.5",
  //   },
  //   {
  //     image: donburi7,
  //     title: "돌솥 알밥",
  //     enTitle: "hot pot with fish roe",
  //     description: "고소한 날치알을 듬뿍 올린 특제 돌솥 알밥",
  //     price: "13.5",
  //   },
  // ],
  noodles: [
    //2025-01-17 김민애님 요청으로 삭제
 //    {
 //      image: noodles1,
 //      title: "차돌니꾸 우동정식",
 //      enTitle: "Beef Brisket Udon Set",
 //      description: "차돌양지 소고기를 듬뿍 얹어 담백한 맛이 일품인 프리미엄 우동",
 // //     price: "14.5",
 //    },
    {
      image: noodles2,
      title: "모리소바 정식",
      enTitle: "Mori Soba Set",
      description: "정통 소바 장인에게 전수받은 眞가츠오 소스에 담궈먹는 소바",
 //     price: "12.5",
    },
    {
      image: noodles3,
      title: "통새우카레 우동정식",
      enTitle: "Shrimp Curry Udon Set",
      description: "통새우 카츠를 올려 카레와 곁들여 먹는 쫄깃한 우동",
//     price: "13.5",
    },
    //2025-01-17 김민애님 요청으로 삭제
 //    {
 //      image: noodles4,
 //      title: "김치 우동정식",
 //      enTitle: "Kimchi Udon Set",
 //      description: "김치와 유부를 곁들여 얼큰한 맛이 일품인 국물 우동",
 // //     price: "13.0",
 //    },
    {
      image: noodles5,
      title: "유부꼬치 우동정식",
      enTitle: "Skewered Fried Tofu Udon Set",
      description: "꼬치 어묵과 유부주머니가 곁들여진 개운한 국물 우동",
 //     price: "13.5",
    },
    {
      image: noodles6,
      title: "카라이 우동정식",
      enTitle: "Spicy Udon Set",
      description: "차돌양지 소고기와 숙주나물, 진한 돈코츠 육수가 어우러진 얼큰한 우동",
 //     price: "13.5",
    },
    // {
    //   image: noodles1,
    //   title: "숯불 니꾸(소고기) 우동",
    //   enTitle: "charcoal-grilled beef udon",
    //   description: "소고기와 숯불 맛이 어우러진 일본식 우동",
    //   price: "14.5",
    // },
    // {
    //   image: noodles2,
    //   title: "카라이 차슈 라멘",
    //   enTitle: "karai barbecued marinated pork ramen",
    //   description: "돈코츠 육수로 만든 진하고 매콤한 차슈 라멘",
    //   price: "13.5",
    // },
    // {
    //   image: noodles3,
    //   title: "카레 우동",
    //   enTitle: "curry udon",
    //   description: "일본 전통식 카레로 만든 우동",
    //   price: "12.0",
    // },
    // {
    //   image: noodles4,
    //   title: "모리소바",
    //   enTitle: "mori soba noodle",
    //   description:
    //     "일본 소바 장인으로부터 전수받은 카에시 소스에 담궈먹는 소바",
    //   price: "12.5",
    // },
  ],
  side: [
    {
      image: side1,
      title: "통새우 카츠(2조각)",
      enTitle: "Shrimp katsu(2pcs)",
      description: "",
 //     price: "6.0",
    },
    {
      image: side2,
      title: "통새우 카츠(5조각)",
      enTitle: "Shrimp katsu(5pcs)",
      description: "",
 //     price: "10.5",
    },
    {
      image: side3,
      title: "미니우동",
      enTitle: "Mini Udon",
      description: "",
//      price: "3.8",
    },
    {
      image: side4,
      title: "카레소스",
      enTitle: "Curry Sauce",
      description: "",
//     price: "3.8",
    },
    {
      image: side5,
      title: "밥",
      enTitle: "Rice",
      description: "",
  //    price: "1.5",
    },
    // {
    //   image: side1,
    //   title: "미니 카츠(2조각)",
    //   enTitle: "mini katsu(2pcs)",
    //   description: "",
    //   price: "3.5",
    // },
    // {
    //   image: side2,
    //   title: "치즈 카츠(2조각)",
    //   enTitle: "cheese katsu(2pcs)",
    //   description: "",
    //   price: "4.0",
    // },
    // {
    //   image: side3,
    //   title: "씨푸드 카츠(2조각)",
    //   enTitle: "sea food katsu(2pcs)",
    //   description: "",
    //   price: "3.5",
    // },
    // {
    //   image: side4,
    //   title: "통새우카츠(2마리/5마리)",
    //   enTitle: "shrimp katsu(2pcs/5pcs)",
    //   description: "",
    //   price: "5.0 / 9.5",
    // },
    // {
    //   image: side5,
    //   title: "고로케(카레/크림치즈)",
    //   enTitle: "curry croquette(curry/cream cheese)",
    //   description: "",
    //   price: "3.5 / 4.5",
    // },
    // {
    //   image: side6,
    //   title: "미니우동",
    //   enTitle: "mini udon",
    //   description: "",
    //   price: "3.8",
    // },
    // {
    //   image: side7,
    //   title: "미니소바",
    //   enTitle: "mini soba noodle",
    //   description: "",
    //   price: "3.8",
    // },
    // {
    //   image: side8,
    //   title: "밥",
    //   enTitle: "rice",
    //   description: "",
    //   price: "1.2",
    // },
    // {
    //   title: "소바 추가(면/장)",
    //   enTitle: "added soba(noodle/soup)",
    //   description: "",
    //   price: "5.0 / 2.0",
    // },
    // {
    //   title: "카레소스",
    //   enTitle: "curry sauce",
    //   description: "",
    //   price: "2.5",
    // },
  ],
};

export default SabotenMenuData;
